import '@fancyapps/fancybox';
import getActionByRoute from './../utils/getActionByRoute';
import coursesTabs from './coursesTabs';
import coursesSelect from './coursesSelect';
import breakpointChecker from './coursesSliders';


const CoursesModule = {
  run: (action) => {
    CoursesModule[action].call();
  },
  index: () => {
    breakpointChecker();
  },
  category: () => {
    breakpointChecker();
  },
  show: () => {
    coursesTabs();
    coursesSelect();
    breakpointChecker();
  }
};

document.addEventListener('DOMContentLoaded', () => {
  CoursesModule.run(getActionByRoute().action);
});



// WEBPACK FOOTER //
// /app/app/assets/javascripts/packs/courses/courses.js